import Component from '../../lib/component'

export default class OverflowAutoComponent extends Component {
    static selector () {
        return [
            '[class*=" overflow-auto"]',
            '[class^="overflow-auto"]',
            '[class*=" overflow-y-auto"]',
            '[class^="overflow-y-auto"]',
            '[class*=" overflow-x-auto"]',
            '[class^="overflow-x-auto"]'
        ].join(',')
    }

    constructor (opts) {
        super(opts)

        this.render()
        this.listen()
    }

    listen () {
        this.el
            .addEventListener('focus',
                this.onFocus.bind(this))

        this.el
            .addEventListener('blur',
                this.onBlur.bind(this))

        this.on('resize',
            this.render.bind(this))

        this.on('resize:debounced',
            this.render.bind(this))

        window.addEventListener('load',
            this.render.bind(this))
    }

    onFocus (e) {
        return this.el.classList.contains('focus-visible')
                && this.el.parentElement
                && !this.el.parentElement.classList
                    .contains('focus-visible-within')
            ? this.el.parentElement.classList
                .add('focus-visible-within')
            : null
    }

    onBlur (e) {
        return this.el.parentElement
                && this.el.parentElement.classList
                    .contains('focus-visible-within')
            ? this.el.parentElement.classList
                .remove('focus-visible-within')
            : null
    }

    render () {
        if (!this.el.getAttribute('tabindex'))
            this.el.setAttribute('tabindex', 0)

        const styles = window.getComputedStyle(this.el) || {}

        const isDirX = (styles.overflowX || '')
            .match(/(auto|scroll|overlay)/)

        const isDirY = (styles.overflowY || '')
            .match(/(auto|scroll|overlay)/)

        if (!isDirX && !isDirY)
            return this.el.setAttribute('tabindex', '-1')

        const isScrollableX = isDirX
            ? this.el.scrollWidth
                > this.el.clientWidth
            : false

        const isScrollableY = isDirY
            ? this.el.scrollHeight
                > this.el.clientHeight
            : false

        const tabindex = this.el.getAttribute('tabindex')

        if (isDirX && isDirY)
            return (tabindex !== '0'
                        && (isScrollableX
                            || isScrollableY))
                    || (tabindex === '0'
                        && !isScrollableX
                        && !isScrollableY)
                ? this.el.setAttribute('tabindex',
                    isScrollableX || isScrollableY
                        ? '0'
                        : '-1')
                : null

        if (isDirX)
            return (tabindex !== '0'
                        && isScrollableX)
                    || (tabindex === '0'
                        && !isScrollableX)
                ? this.el.setAttribute('tabindex',
                    isScrollableX
                        ? '0'
                        : '-1')
                : null

        if (isDirY)
            return (tabindex !== '0'
                        && isScrollableY)
                    || (tabindex === '0'
                        && !isScrollableY)
                ? this.el.setAttribute('tabindex',
                    isScrollableY
                        ? '0'
                        : '-1')
                : null
    }
}
